// extracted by mini-css-extract-plugin
export default {"collapsible":"sqcdY","title":"ktsGD","content":"_3LKR2","collapsed":"r0A-s","collapsedContent":"_2Xxwd"};